import React from 'react';
import './index.scss';
import { IMGURL } from 'lib/config';
import QueueAnim from 'rc-queue-anim';
import { OverPack } from 'rc-scroll-anim';
import CountUp from 'react-countup';
interface IProps {
  dataInfo: {
    img: string;
  };
}
const JdInsure = (props: IProps) => {
  const { img } = props.dataInfo;
  return (
    <OverPack
      playScale={0.1}
      // @ts-ignore
      always={false}
    >
      <QueueAnim key='queue' type={'bottom'} delay={100} duration={600}>
        {/* <div className="jd_insure" key="jd_insure">
          <div className="jd_insure_wrap">
            <img src={`${IMGURL}${img}`} alt="img" className="img" />
          </div>
        </div> */}

        <div className='jd_insure2' key='jd_insure'>
          <div className='jd_insure_wrap'>
            <div className='left'>
              <p className='p_1'>
                京东安联保险由京东集团与德国安联集团在2018年合力打造
              </p>
              <p className='p_2'>
                为个人和企业客户提供电商互联网保险、意外健康保险、汽车保险等，致力于成为最值得信赖的保险服务供应商。
              </p>
            </div>
            <div className='middle'></div>
            <div className='right'>
              <div className='r_item_wrap'>
                <div className='r_item'>
                  <div className='r_top'>
                    <span className='r_left'>
                      <CountUp
                        end={2.47}
                        start={0}
                        duration={1.2}
                        decimals={2}
                      />
                    </span>
                    <span className='r_right'>亿</span>
                  </div>
                  {/* <div className='r_bottom'>累计服务用户数 (人)</div> */}
                  <div className='r_bottom'>年服务用户数（人）</div>
                </div>
                <div className='r_item'>
                  <div className='r_top'>
                    <span className='r_left'>
                      <CountUp end={24.2} start={0} duration={1.2} decimals={1}/>
                    </span>
                    <span className='r_right'>万亿</span>
                  </div>
                  <div className='r_bottom'>累计保额 （元）</div>
                </div>
                <div className='r_item'>
                  <div className='r_top'>
                    <span className='r_left'>
                      <CountUp
                        end={2739.3}
                        start={0}
                        duration={1.2}
                        decimals={1}
                      />
                    </span>
                    <span className='r_right'>万</span>
                  </div>
                  <div className='r_bottom'>累计赔付案件数（件）</div>
                </div>
              </div>
              <p className='r_b'>
              以上为京东安联财产保险有限公司截止2023年7月的统计数据
              </p>
            </div>
          </div>
        </div>
      </QueueAnim>
    </OverPack>
  );
};

export default JdInsure;
